export default __webpack_public_path__ + "static/media/ic_video.b23c336e.svg";